module.exports = __webpack_public_path__ + "static/img/WLT1550-1.jpg 18-04-13-794.78b6e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/WLT1550-1.jpg 18-04-13-794.jpg
// module id = FWU+
// module chunks = 0